import styled from 'styled-components'
import { colors } from '../../theme'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding-left: 5px;
`

export const Wrapper = styled.span<{ background: string }>`
  background-color: ${({ background }) => background};
  border-radius: 15px;
  padding-right: 15px;
  width: 100%;
  box-shadow: 5px 5px 15px ${colors.overlay};

  &.noGraphic {
    padding: 20px 50px 15px 18px;
  }
`
export const Div = styled.div`
  display: flex;
`
